export default "__VITE_ASSET__Dj9s3HWl__"